module.exports = __webpack_public_path__ + "img/SESSIONS2.9199eda9.png";